module.exports = __webpack_public_path__ + "assets/img/banner.e42dca06.jpg";